import React, { useReducer } from 'react';
import styled from 'styled-components';
import { useAppSelector } from '@src/core/hooks';
import { errorsSelector } from '../../../features/auth';
import Eye from '../../../icons/eye.svg';
import EyeOff from '../../../icons/eye-off.svg';
import { AuthValidation } from '../StyledComponents/AuthStyled';
import { getErrorMessage } from '@src/common';
import { InputArea, InputAttribute, InputLabel } from '../StyledComponents/InputStyled';
import { FormInputType } from '@src/core/buyerApiClient';
import { LayoutColors } from '@src/core/theme';

interface InputPasswordProps {
  name: string;
  type?: FormInputType;
  label?: string;
  errorContext?: string;
  issetError?: boolean;
  value?: string | number;
  required?: boolean;
  autoComplete?: boolean;
  showInfo?: string;
}

const InputPassword = ({ name, label, errorContext, required, autoComplete = true, showInfo }: InputPasswordProps) => {
  const [passwordShow, setPasswordShow] = useReducer((state) => !state, false);

  const errors = useAppSelector(errorsSelector);
  const errorMessage = getErrorMessage(errors[errorContext!], name);

  return (
    <InputArea>
      <InputLabel htmlFor={name}>{label}</InputLabel>
      <InputAttibutePassword
        errorContext={errorContext}
        label={label}
        name={name}
        id={name}
        type={passwordShow ? 'text' : 'password'}
        $issetError={!!errorMessage}
        required={required}
        autoComplete={autoComplete ? 'on' : name}
      />
      <ButtonToggleShowPassword onClick={() => setPasswordShow()}>
        {passwordShow ? <Eye /> : <EyeOff />}
      </ButtonToggleShowPassword>
      {!errorMessage && showInfo ? (
        <ShowInfoMessage>{showInfo}</ShowInfoMessage>
      ) : (
        <AuthValidation>{errorMessage}</AuthValidation>
      )}
    </InputArea>
  );
};

const InputAttibutePassword = styled(InputAttribute)`
  padding-right: 35px;
`;

const ButtonToggleShowPassword = styled.div`
  display: inline-flex;
  position: absolute;
  margin-left: -30px;
  margin-top: 7px;
  cursor: pointer;
`;

const ShowInfoMessage = styled(AuthValidation)`
  color: ${LayoutColors.blackMain};
`;

export default InputPassword;
